import React from 'react';
import { useNavigate } from 'react-router-dom';

export default function ErrorPage() {
  const navigate = useNavigate();

  const errorPageStyle = {
    fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '100vh',
    margin: 0,
    textAlign: 'center',
    overflow: 'hidden',
    position: 'relative',
    padding: '20px'
  };

  const containerStyle = {
    backgroundColor: '#ffffff',
    borderRadius: '24px',
    padding: '60px 40px',
    boxShadow: '0 25px 50px rgba(0, 0, 0, 0.15)',
    maxWidth: '600px',
    width: '100%',
    position: 'relative',
    animation: 'fadeInUp 0.8s ease-out',
    zIndex: 1
  };

  const logoStyle = {
    maxWidth: '120px',
    marginBottom: '32px',
    display: 'block',
    marginLeft: 'auto',
    marginRight: 'auto',
    filter: 'drop-shadow(0 4px 8px rgba(0, 0, 0, 0.1))'
  };

  const iconStyle = {
    width: '80px',
    height: '80px',
    margin: '0 auto 24px',
    backgroundColor: '#f8fafc',
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '36px',
    color: '#64748b'
  };

  const h1Style = {
    color: '#1e293b',
    fontSize: '2.25rem',
    fontWeight: '700',
    marginBottom: '16px',
    lineHeight: '1.2'
  };

  const pStyle = {
    color: '#64748b',
    fontSize: '1.125rem',
    lineHeight: '1.7',
    marginBottom: '32px',
    maxWidth: '480px',
    margin: '0 auto 32px'
  };

  const buttonContainerStyle = {
    display: 'flex',
    gap: '16px',
    justifyContent: 'center',
    flexWrap: 'wrap',
    marginBottom: '24px'
  };

  const primaryButtonStyle = {
    backgroundColor: '#3b82f6',
    color: 'white',
    border: 'none',
    borderRadius: '12px',
    padding: '14px 28px',
    fontSize: '1rem',
    fontWeight: '600',
    cursor: 'pointer',
    transition: 'all 0.2s ease',
    textDecoration: 'none',
    display: 'inline-flex',
    alignItems: 'center',
    gap: '8px'
  };

  const secondaryButtonStyle = {
    backgroundColor: 'transparent',
    color: '#64748b',
    border: '2px solid #e2e8f0',
    borderRadius: '12px',
    padding: '12px 26px',
    fontSize: '1rem',
    fontWeight: '600',
    cursor: 'pointer',
    transition: 'all 0.2s ease',
    textDecoration: 'none',
    display: 'inline-flex',
    alignItems: 'center',
    gap: '8px'
  };

  const errorCodeStyle = {
    color: '#94a3b8',
    fontSize: '0.875rem',
    fontWeight: '500',
    letterSpacing: '0.05em'
  };

  const backgroundStyle = {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundImage: `
      radial-gradient(circle at 25% 25%, rgba(255, 255, 255, 0.1) 0%, transparent 50%),
      radial-gradient(circle at 75% 75%, rgba(255, 255, 255, 0.1) 0%, transparent 50%)
    `,
    zIndex: 0
  };

  const handleGoHome = () => {
    if (navigate) {
      navigate('/');
    } else {
      window.location.href = '/';
    }
  };

  const handleGoBack = () => {
    window.history.back();
  };

  return (
    <>
      <style>{`
        @keyframes fadeInUp {
          0% {
            opacity: 0;
            transform: translateY(30px);
          }
          100% {
            opacity: 1;
            transform: translateY(0);
          }
        }
        
        .primary-button:hover {
          background-color: #2563eb !important;
          transform: translateY(-2px);
          box-shadow: 0 10px 25px rgba(59, 130, 246, 0.3);
        }
        
        .secondary-button:hover {
          border-color: #cbd5e1 !important;
          background-color: #f8fafc !important;
          transform: translateY(-2px);
        }
        
        @media (max-width: 640px) {
          .error-container {
            padding: 40px 24px !important;
            margin: 16px !important;
          }
          .error-title {
            font-size: 1.875rem !important;
          }
          .error-description {
            font-size: 1rem !important;
          }
          .button-container {
            flex-direction: column !important;
          }
        }
      `}</style>
      <div style={errorPageStyle}>
        <div style={backgroundStyle}></div>
        <div style={containerStyle} className="error-container">
          <img src="https://yooldigital.com/assets/yooladmin.svg" alt="Yool Logo" style={logoStyle} />
          
          <div style={iconStyle}>
            <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <circle cx="12" cy="12" r="10"></circle>
              <line x1="12" y1="8" x2="12" y2="12"></line>
              <line x1="12" y1="16" x2="12.01" y2="16"></line>
            </svg>
          </div>
          
          <h1 style={h1Style} className="error-title">Página no encontrada</h1>
          <p style={pStyle} className="error-description">
            Lo sentimos, la página que estás buscando no existe o ha sido movida. 
            Verifica la URL o regresa al dashboard principal.
          </p>
          
          <div style={buttonContainerStyle} className="button-container">
            <button 
              style={primaryButtonStyle} 
              className="primary-button"
              onClick={handleGoHome}
            >
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="m3 9 9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
                <polyline points="9,22 9,12 15,12 15,22"></polyline>
              </svg>
              Ir al Dashboard
            </button>
            
            <button 
              style={secondaryButtonStyle} 
              className="secondary-button"
              onClick={handleGoBack}
            >
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="m12 19-7-7 7-7"></path>
                <path d="M19 12H5"></path>
              </svg>
              Volver atrás
            </button>
          </div>
          
          <div style={errorCodeStyle}>ERROR 404</div>
        </div>
      </div>
    </>
  );
}